import { DatePicker } from 'antd';
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import Ribbon from '../../../../core/common/ribbon/ribbon';
import TextField from '../../../../core/common/textFields/TextField';
import { useCreateUpdateFundingMutation, useGetFundingDetailsByIdQuery } from '../../../../services/EndPointsApis';
import NumberField from '../../../../core/common/textFields/NumberField';
import { usePermission } from '../../../../core/hooks/PermissionHook';
import { constantsPermission } from '../../../../Config/Constants';

const FundingTab = ({ projectId, refetchClientView }: any) => {
    //PermissionHook
    const { view: viewFunding, edit: editFunding, create: createFunding } = usePermission(constantsPermission?.moduleId?.funding);


    dayjs.extend(customParseFormat);

    const location = useLocation()
    const isReadOnly = location.pathname.includes('/projects/view-project');

    const ProjectId = useSelector((state: any) => state.common.projectId);
    // const projectID = ProjectId[0]
    //Get Funding By Id
    const { data: fundingByIdData, refetch } = useGetFundingDetailsByIdQuery({ projectId: projectId });
    // const [createFunding, { data:fundingByIdData }] = useCreateUpdateFundingMutation();

    //Create Funding BY Id
    const [createFundingApi, { data, isError, error, isSuccess, isLoading }] = useCreateUpdateFundingMutation();


    const initialValues = {
        id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        projectId: projectId,
        active: true,
        createdOn: "2024-10-31T08:04:27.371Z",
        updatedOn: "2024-10-31T08:04:27.371Z",
        isFinanced: false,
        isCash: false,
        isOwnersBank: false,
        isFarmedOut: false,
        isLFC: false,
        loanOfficer: "",
        financer: "",
        lfcLender: "",
        lenderContact: "",
        preApproval: "",
        fileSubmitted: "",
        loanFunded: "",
        thirdPartyEscrow: "",
        finalApproval: "",
        loanAmount: 0,
        amtAvailForFundingJob: 0,
        isSLP: false,
        slpLoanPct: 0,
        fundingDueClose: 0,
        loanAppDate: "2024-10-31T08:04:27.371Z",
        closingDate: "2024-10-31T08:04:27.371Z",
        notes: ""
    }

    const formik = useFormik({
        initialValues,
        // validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            createFundingApi(values)
        }
    })

    useEffect(() => {
        if (isSuccess) {
            toast.success(data?.message);
            refetch()
            refetchClientView()
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    }, [isError, error]);

    useEffect(() => {
        if (fundingByIdData?.result && Object.keys(fundingByIdData?.result).length > 0) {
            // setUpdateId(fundingByIdData?.result?.id);
            formik.setValues({ ...fundingByIdData?.result, projectId: projectId });
        } else {
            // setUpdateId(0);
        }
    }, [fundingByIdData]);

    const handleCloseDate = (date: Dayjs | null) => {
        // setSelectedFreshAptDate(date);
        formik.setFieldValue('closingDate', date);
    };
    const handleLoanAppDate = (date: Dayjs | null) => {
        // setSelectedFreshAptDate(date);
        formik.setFieldValue('loanAppDate', date);
    };

    const formatComma = (num: number | string) => {
        if (num === null || num === undefined) return "0.0";
        const numericValue = String(num).replace(/,/g, "");
        if (isNaN(Number(numericValue))) return String(num);
        return Number(numericValue).toLocaleString();
    };

    return (
        <>
            {editFunding &&
                <Ribbon
                    buttonClass='ribbon-btn'
                    buttonText='Save'
                    onClickbtn={formik.handleSubmit}
                />
            }
            <div className='card'>
                <div className='card-body'>
                    <form onSubmit={formik.handleSubmit}>
                        <div className='row'>
                            <div className="col-md-7">
                                <div className='card'>
                                    <div className='card-body card-css'>
                                        <h5 className='mb-3'>Loan Details</h5>
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <TextField
                                                    leftLabel="LFC Lender"
                                                    {...formik.getFieldProps("lfcLender")}
                                                // value={new Date(item.dueDate).toLocaleString()}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <TextField
                                                    leftLabel="Lender Contact"
                                                    {...formik.getFieldProps("lenderContact")}
                                                // value={new Date(item.dueDate).toLocaleString()}
                                                />
                                            </div>
                                            <div className="col-md-6 mt-3  ">
                                                <NumberField
                                                    leftLabel="Loan Amount"
                                                    type="text"
                                                    fieldClass="text-end"
                                                    required
                                                    min={0}
                                                    name="loanAmount"
                                                    formik={formik}
                                                    value={formik.values.loanAmount}
                                                />
                                            </div>
                                            <div className="col-md-6 mt-3  ">
                                                <NumberField
                                                    leftLabel="Amt Avail For Funding"
                                                    type="text"
                                                    fieldClass="text-end"
                                                    required
                                                    min={0}
                                                    name="amtAvailForFundingJob"
                                                    formik={formik}
                                                    value={formik.values.amtAvailForFundingJob}
                                                />
                                            </div>
                                            <div className="col-md-6 mt-3 ">
                                                <TextField
                                                    leftLabel="Pre-Approval"
                                                    {...formik.getFieldProps("preApproval")}
                                                // value={new Date(item.dueDate).toLocaleString()}
                                                />
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <label className="input-label w-50 ">
                                                        Loan App Date
                                                    </label>
                                                    <DatePicker
                                                        className="form-control datetimepicker deals-details w-50 "
                                                        onChange={handleLoanAppDate}
                                                        value={formik.values?.loanAppDate ? dayjs(formik.values?.loanAppDate, 'mmm-dd-yyyy') : null}
                                                        format="MMM-DD-YYYY"

                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-3 ">
                                                <TextField
                                                    leftLabel="File Submitted"
                                                    {...formik.getFieldProps("fileSubmitted")}
                                                // value={new Date(item.dueDate).toLocaleString()}
                                                />
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <TextField
                                                    leftLabel="Final Approval"
                                                    {...formik.getFieldProps("finalApproval")}
                                                // value={new Date(item.dueDate).toLocaleString()}
                                                />
                                            </div>
                                            <div className="col-md-6 mt-3 ">
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <label className="input-label w-50 ">
                                                        Closing  Date
                                                    </label>
                                                    <DatePicker
                                                        className="form-control datetimepicker deals-details w-50 "
                                                        onChange={handleCloseDate}
                                                        value={formik.values?.closingDate ? dayjs(formik.values?.closingDate, 'mmm-dd-yyyy') : null}
                                                        format="MMM-DD-YYYY"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-3  ">
                                                <NumberField
                                                    leftLabel="Funding Due @ Close"
                                                    type="text"
                                                    fieldClass="text-end"
                                                    required
                                                    min={0}
                                                    name="fundingDueClose"
                                                    formik={formik}
                                                    value={formik.values.fundingDueClose}
                                                />
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <TextField
                                                    leftLabel="Loan Funded"
                                                    {...formik.getFieldProps("loanFunded")}
                                                // value={new Date(item.dueDate).toLocaleString()}
                                                />
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <TextField
                                                    leftLabel="3rd Party Escrow"
                                                    {...formik.getFieldProps("thirdPartyEscrow")}
                                                // value={new Date(item.dueDate).toLocaleString()}
                                                />
                                            </div>
                                            <div className="col-md-6 mt-3 d-flex ">
                                                <label className="input-label w-50">
                                                    SLP?
                                                </label>
                                                <label className="checkboxs mt-2">
                                                    <input
                                                        type="checkbox"
                                                        checked={formik.values.isSLP}
                                                        // disabled={viewOnly}
                                                        {...formik.getFieldProps("isSLP")}
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </div>
                                            <div className="col-md-6 mt-3  ">
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <NumberField
                                                        leftLabel="SLP% Of Loan"
                                                        type="text"
                                                        fieldClass="text-end"
                                                        required
                                                        min={0}
                                                        name="slpLoanPct"
                                                        formik={formik}
                                                        value={formik.values.slpLoanPct}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-5">
                                <div className='card' style={{ height: '473px' }}>
                                    <div className='card-body card-css'>
                                        <h5 className='mb-3'>Financed</h5>
                                        <div className='row mt-3'>
                                            <div className='col-md-12'>
                                                <div className='d-flex'>
                                                    <label className='input-label w-25'>Loan Officer</label>
                                                    <input type='text' className='form-control w-50'
                                                        {...formik.getFieldProps("loanOfficer")}
                                                    />
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className="col-md-12 d-flex">
                                                    <label className="input-label w-25">
                                                        Financed?
                                                    </label>
                                                    <label className="checkboxs mt-2 mb-3 ms-2">
                                                        <input
                                                            type="checkbox"
                                                            checked={formik.values.isFinanced}
                                                            // disabled={viewOnly}
                                                            {...formik.getFieldProps("isFinanced")}
                                                        />
                                                        <span className="checkmarks" />
                                                    </label>
                                                </div>
                                            </div>
                                            <div className='col-md-12 mt-3'>
                                                <div className='d-flex'>
                                                    <label className='input-label w-25'>Financer</label>
                                                    <input type='text' className='form-control w-50'
                                                        {...formik.getFieldProps("financer")}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12 d-flex ">
                                                <label className="input-label w-25">
                                                    Cash?
                                                </label>
                                                <label className="checkboxs mt-2 mb-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={formik.values.isCash}
                                                        // disabled={viewOnly}
                                                        {...formik.getFieldProps("isCash")}
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12 d-flex ">
                                                <label className="input-label w-25">
                                                    Owners Bank?
                                                </label>
                                                <label className="checkboxs mt-2 mb-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={formik.values.isOwnersBank}
                                                        // disabled={viewOnly}
                                                        {...formik.getFieldProps("isOwnersBank")}
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </div>
                                        </div>
                                        {formik.values?.isOwnersBank === true &&
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='d-flex'>
                                                        <label className='input-label w-25'>Owner Bank</label>
                                                        <input type='text' className='form-control w-50'
                                                            {...formik.getFieldProps("ownersBankName")}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <div className='row'>
                                            <div className="col-md-12 d-flex ">
                                                <label className="input-label w-25">
                                                    Farmed Out?
                                                </label>
                                                <label className="checkboxs mt-2 mb-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={formik.values.isFarmedOut}
                                                        // disabled={viewOnly}
                                                        {...formik.getFieldProps("isFarmedOut")}
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </div>
                                        </div>
                                        <div className='row mb-2'>
                                            <div className="col-md-12 d-flex ">
                                                <label className="input-label w-25">
                                                    LFC?
                                                </label>
                                                <label className="checkboxs mt-2 mb-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={formik.values.isLFC}
                                                        // disabled={viewOnly}
                                                        {...formik.getFieldProps("isLFC")}
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </div>
                                        </div>

                                        {/* <div className='row'>
                                    <div className="col-md-12 ">
                                        <TextField
                                            labelClass='w-25'
                                            leftLabel="Loan Officer"
                                            {...formik.getFieldProps("loanOfficer")}
                                        // value={new Date(item.dueDate).toLocaleString()}
                                        />
                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <TextField
                                            leftLabel="Financer"
                                            {...formik.getFieldProps("financer")}
                                        // value={new Date(item.dueDate).toLocaleString()}
                                        />
                                    </div>
                                </div> */}

                                    </div>
                                </div>
                            </div>
                            {/* <div className='col-md-2'></div> */}

                            <div className='col-md-12 mt-3'>
                                <label className='input-label'>Notes</label>
                                <textarea className='form-control' rows={3}
                                    {...formik.getFieldProps("notes")}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </>
    )
}

export default FundingTab